import { render, staticRenderFns } from "./transfer.vue?vue&type=template&id=49db2e08&"
import script from "./transfer.vue?vue&type=script&lang=js&"
export * from "./transfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49db2e08')) {
      api.createRecord('49db2e08', component.options)
    } else {
      api.reload('49db2e08', component.options)
    }
    module.hot.accept("./transfer.vue?vue&type=template&id=49db2e08&", function () {
      api.rerender('49db2e08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/complaintManage/suggestQuery/transfer.vue"
export default component.exports